
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { ModalCampaignQuestion } from '@/types/modalCampaigns';

interface QuizQuestionProps {
  question: ModalCampaignQuestion;
  questionIndex: number;
  userAnswers: string[];
  onAnswerChange: (questionId: string, option: string, checked: boolean) => void;
}

const QuizQuestion: React.FC<QuizQuestionProps> = ({
  question,
  questionIndex,
  userAnswers,
  onAnswerChange
}) => {
  return (
    <div className="space-y-3">
      <div className="font-medium">
        {questionIndex + 1}. {question.question_text} 
        <span className="text-sm text-muted-foreground ml-2">
          ({question.points} {question.points === 1 ? 'punt' : 'punten'})
        </span>
      </div>
      
      <div className="space-y-2 pl-6">
        {question.options.map((option, index) => {
          const optionKey = `${question.id}-option-${index}`;
          const isChecked = userAnswers.includes(option);
          
          return (
            <div className="flex items-center space-x-2" key={optionKey}>
              <Checkbox 
                id={optionKey} 
                checked={isChecked}
                onCheckedChange={(checked) => 
                  onAnswerChange(question.id, option, !!checked)
                }
              />
              <Label htmlFor={optionKey} className="cursor-pointer">{option}</Label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizQuestion;
